<div class="ibm--validation-error" *ngIf="attachedTo?.invalid && ((!validateOnSubmitOnly && attachedTo.touched) || formSubmitted)">
  <ng-container *ngFor="let error of errors">
    {{error}}
    <br />
  </ng-container>
</div>